import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/Remove.svg'

export const IconRemove = IconSVG as IconComponent
